import { connect } from 'react-redux';
import { getModals } from './redux/selectors';
import { popModal } from './redux/actionCreators';
import { getCurrentUser } from '../publicSession/selectors';
import { takeLast } from '../utils/fp';
/** 2 for now to support a modal + a confirmation modal on top */ const ARBITRARY_MODAL_LIMIT = 2;
export const mapStateToProps = (state)=>({
        modals: takeLast(ARBITRARY_MODAL_LIMIT, getModals(state)),
        currentUser: getCurrentUser(state)
    });
export const mapDispatchToProps = {
    popModal
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=Modals.container.js.map